import React from 'react';
export const DEFAULT_DETAILS_CONTEXT = {
    isMobileDrawerOpen: false,
    pricingCalendarInitialLoad: false,
    showPricingCalendar: false,
};
export const HotelDetailsContext = React.createContext({
    state: DEFAULT_DETAILS_CONTEXT,
    dispatch: () => null,
});
export function useHotelDetailsContext() {
    const context = React.useContext(HotelDetailsContext);
    return React.useMemo(() => context, [context]);
}
